import { css, cva } from "@stubhub/broadway-foundation/css";

export const card = css({
  width: "[60px]",
  height: "[60px]",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  textAlign: "center",
  overflowX: "hidden",
  overflowY: "hidden",
  textTransform: "uppercase",
  color: "var(--component-icon-color)",
});

export const cardBorderedExplore = css({
  width: "[60px]",
  height: "[60px]",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  textAlign: "center",
  overflowX: "hidden",
  overflowY: "hidden",
  textTransform: "uppercase",
  color: "var(--component-icon-color)",
  borderBlockStartStyle: "solid",
  borderBlockEndStyle: "solid",
  borderInlineStartStyle: "solid",
  borderInlineEndStyle: "solid",
  borderBlockStartColor: "border",
  borderBlockEndColor: "border",
  borderInlineStartColor: "border",
  borderInlineEndColor: "border",
  borderBlockStartWidth: "primitives.25",
  borderBlockEndWidth: "primitives.25",
  borderInlineStartWidth: "primitives.25",
  borderInlineEndWidth: "primitives.25",
  borderStartStartRadius: "element.extraSmall",
  borderStartEndRadius: "element.extraSmall",
  borderEndStartRadius: "element.extraSmall",
  borderEndEndRadius: "element.extraSmall",
});

export const largerDayTextRecipe = cva({
  base: {
    fontSize: "primitives.500",
  },
  variants: {
    textColor: {
      default: {},
      brand: { color: "text.brand" },
    },
  },
  defaultVariants: { textColor: "default" },
});

export const dayOfWeekContainerRecipe = cva({
  base: {
    width: "full",
    paddingInline: "primitives.25",
  },
  variants: {
    bgVariant: {
      brand: { backgroundColor: "bg.surface.brand" },
      noBrand: { backgroundColor: "bg.surface.strong" },
    },
  },
  defaultVariants: { bgVariant: "noBrand" },
});
